'use client';

import { PropsWithChildren } from 'react';

import Image from 'next/image';

import Page from 'components/shared/layout/Page';

import robotSrc from 'public/error/robot.png';

interface ErrorScreenProps {
  title?: string;
  description: string;
}

/**
 * Shared error/404 presentation used by `app/error.tsx`, `app/global-error.tsx`
 * and `app/not-found.tsx`. Reporting (Sentry) stays in the call sites, since
 * each surfaces the error differently.
 */
const ErrorScreen = ({
  title = 'Sorry, something is wrong here!',
  description,
  children,
}: PropsWithChildren<ErrorScreenProps>) => {
  return (
    <Page>
      <section className="flex min-h-[100vh] w-full flex-grow flex-col items-center justify-center p-4 text-center text-black dark:text-white">
        <h1 className="mb-6 text-[34px] font-bold leading-tight">{title}</h1>
        <p className="text-2xl font-thin">{description}</p>

        <div className="relative mt-6 aspect-square w-full max-w-[460px]">
          <Image
            alt="Robot"
            src={robotSrc}
            fill
            sizes="(max-width: 460px) 100vw, 460px"
            loading="lazy"
            placeholder="blur"
          />
        </div>

        {children}
      </section>
    </Page>
  );
};

export default ErrorScreen;
